export const thumbnailUrl = (url, size = 100, disableCover = false) => `https://images.weserv.nl/?url=${encodeURI(url)}&w=${size}${!disableCover ? `&h=${size}&fit=cover&a=attention` : ""}`;
